// Minimized floating checkout bar (Part 3): shown while a server-authoritative
// hold is active but the driver has minimized/left the checkout panel. The
// countdown derives from hold_expires_at + the server clock offset — never the
// browser clock — and the parent clears all checkout state at expiry.
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { useHoldCountdown } from "../lib/holdTimer";

export default function CheckoutHoldBar({ booking, spotTitle, onContinue }) {
  // Shared server-authoritative timer (Part A4): hold_expires_at + server_now.
  const left = useHoldCountdown(booking);

  const show = !!booking && left != null && left > 0;
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.97 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="fixed z-40 inset-x-4 bottom-[max(1rem,env(safe-area-inset-bottom))] sm:inset-x-0 sm:bottom-6 sm:mx-auto sm:max-w-md"
          data-testid="checkout-hold-bar"
          role="status"
        >
          <div className="rounded-2xl border border-[#E50914]/30 bg-[#0D1114]/85 backdrop-blur-xl shadow-[0_8px_40px_rgba(0,0,0,0.55),0_0_36px_rgba(229,9,20,0.18)] px-5 py-4">
            <div className="flex items-center justify-between gap-4">
              <div className="min-w-0">
                <p className="flex items-center gap-1.5 text-[9px] font-bold uppercase tracking-[0.16em] text-[#FF3B45]">
                  <ShieldCheck className="w-3 h-3" aria-hidden="true" /> Spot held for you
                </p>
                <p className="mt-1 text-sm font-semibold truncate" data-testid="hold-bar-spot">{spotTitle}</p>
                <p className="text-xs text-zinc-500 tabular-nums" data-testid="hold-bar-countdown" aria-live="polite">
                  {String(Math.floor(left / 60)).padStart(2, "0")}:{String(left % 60).padStart(2, "0")} remaining
                </p>
              </div>
              <button
                onClick={onContinue}
                data-testid="hold-bar-continue"
                className="btn-primary !h-11 !px-4 text-xs shrink-0 shadow-[0_0_20px_rgba(229,9,20,0.35)]"
              >
                Continue Reservation <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
